import { useEffect, useMemo, useRef } from "react";
import {
  APP_COMPONENT_DOCUMENTS_VIEWER_PATH,
  APP_COMPONENT_DOCUMENTS_VIEWER_USE_BUILDIN_DESKTOP,
} from "../../constants/constants";
import { t } from "i18next";

const USE_DESKTOP_BUILD_IN_VIEWER =
  APP_COMPONENT_DOCUMENTS_VIEWER_USE_BUILDIN_DESKTOP;
const USE_MERGE = false;

const PDFViewer = ({ ...props }) => {
  const data = props.data;
  const viewerPath = props.viewer || APP_COMPONENT_DOCUMENTS_VIEWER_PATH;
  const { maxHeight, maxWidth } = props;

  const pdfData = useMemo(() => {
    if (!data || !data.fileContent) return;

    if (USE_MERGE) {
      return;
    }

    if (USE_DESKTOP_BUILD_IN_VIEWER) {
      return `data:application/pdf;base64,${data.fileContent}`;
    }
    return data.fileContent;
  }, [data]);

  const pdfPages = useMemo(() => {
    if (!data || !data.numberOfPages) return;

    if (USE_MERGE) {
      return;
    }

    return data.numberOfPages;
  }, [data]);

  const pdfViewerUrl = useMemo(() => {
    if (USE_DESKTOP_BUILD_IN_VIEWER && pdfData) {
      return pdfData;
    }
    return viewerPath;
  }, [pdfData, viewerPath]);

  const pdfViewerIframe = useRef(null);

  useEffect(() => {
    if (pdfData && pdfViewerIframe.current) {
      setTimeout(() => {
        pdfViewerIframe.current?.contentWindow?.postMessage(
          {
            data: pdfData,
            pages: pdfPages,
          },
          window.location.origin
        );
      }, 100);
    }
  }, [pdfData, pdfPages]);

  if (!pdfViewerUrl) return null;

  return (
    <>
      {pdfViewerUrl && USE_DESKTOP_BUILD_IN_VIEWER && (
        <object
          data={pdfViewerUrl}
          title={t("components.documents.title")}
          type="application/pdf"
          width={maxWidth}
          height={maxHeight}
        >
          <iframe
            title={t("components.documents.title")}
            src={pdfViewerUrl}
            width={maxWidth}
            height={maxHeight}
            ref={pdfViewerIframe}
          >
            <p>This browser does not support PDF!</p>
          </iframe>
        </object>
      )}

      {pdfViewerUrl &&
        (!USE_DESKTOP_BUILD_IN_VIEWER || USE_DESKTOP_BUILD_IN_VIEWER) && (
          <iframe
            title={t("components.documents.title")}
            ref={pdfViewerIframe}
            src={pdfViewerUrl}
            width={maxWidth}
            height={maxHeight}
            style={{ border: "1px solid #ffffff", margin: "0 auto" }}
          ></iframe>
        )}
    </>
  );
};

export default PDFViewer;
